import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { GetEmployeeCardDetails } from '../../../services/human-resource';

const sceneStyle = {
    width: 380,
    height: 640,
    cursor: 'default',
};

const cardStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    border: '2px solid #081B8E',
    background: '#fff',
    overflow: 'hidden',
};

export default function ContractIdCard({ data = {} }) {
    const {
        empName,
        empId,
        empPhotoUrl,
    } = data;

    const [photoUrl, setPhotoUrl] = useState(
        empPhotoUrl || `https://hrms.sswhite.co/pic/${empId}.png`
    );

    useEffect(() => {
        const loadPhoto = async () => {
            try {
                const response = await GetEmployeeCardDetails(empId);
                const picture =
                    response.data?.employeeDetails?.[0]?.picture;

                setPhotoUrl(
                    picture
                        ? `https://dashboardapi.sswhite.co/SSWhiteImages/${picture}`
                        : `https://hrms.sswhite.co/pic/${empId}.png`
                );
            } catch {
                setPhotoUrl(
                    `https://hrms.sswhite.co/pic/${empId}.png`
                );
            }
        };

        if (empId) {
            loadPhoto();
        }
    }, [empId]);

    return (
        <Box sx={sceneStyle} className="contract-id-card-scene">
            <Box sx={cardStyle} className="contract-id-card-face contract-id-card">
                {/* Image area */}
                <Box
                    sx={{
                        width: '88%',
                        height: 340,
                        border: '1px solid #d8d8d8',
                        mx: 'auto',
                        mt: 10,
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                    }}
                >
                    {empPhotoUrl && (
                        <Box
                            component="img"
                            key={empPhotoUrl}
                            src={photoUrl}
                            alt={empName || "Employee"}
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                            }}
                            onLoad={(event) => {
                                event.currentTarget.style.display = "block";
                            }}
                            onError={(event) => {
                                const image = event.currentTarget;

                                if (image.src.includes("dashboardapi.sswhite.co")) {
                                    image.onerror = null;
                                    image.src = `https://hrms.sswhite.co/pic/${empId}.png`;
                                    return;
                                }

                                image.onerror = null;
                                image.style.display = "none";
                            }}
                        />
                    )}
                </Box>

                {/* Name */}
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Typography
                        sx={{
                            color: '#002b7a',
                            fontWeight: 900,
                            fontSize: '1.6rem',
                            letterSpacing: '0.02em',
                            textTransform: 'none',
                            fontFamily: 'Arial, Helvetica, sans-serif',
                        }}
                    >
                        {empName}
                    </Typography>
                </Box>

                {/* ID */}
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            bgcolor: '#081B8E',
                            color: '#fff',
                            px: 2,
                            py: 0.5,
                            fontWeight: 900,
                            fontSize: '20px',
                            borderRadius: '4px',
                            minWidth: 72,
                            textAlign: 'center',
                        }}
                    >
                        {empId}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
